import { Routes, Route, Navigate } from 'react-router-dom';

import HomePage from './pages/HomePage';
import DictionaryPage from './pages/DictionaryPage';
import SesothoPage from './pages/AboutUs/SesothoPage';
import WordOfTheDayPage from './pages/WordOfTheDayPage';
import About from './pages/AboutUs/About';
import SearchResultPage from './pages/SearchResultPage';
import FutureLexPage from './pages/AboutUs/FuturelexPage';
import ContentWrapper from './components/layout/ContentWrapper';
import Authorise from './components/auth/Authorise';

function App() {
  return (
    <>
      <ContentWrapper>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/dictionary" element={<DictionaryPage />} />
          <Route path="/word-of-the-day" element={<WordOfTheDayPage />} />
          <Route path="/about-sesotho" element={<SesothoPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/about-futurelex" element={<FutureLexPage />} />
          <Route path="/search-result/:search" element={<SearchResultPage />} />
          <Route path="/authorise" element={<Authorise />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        </ContentWrapper>
    </>
  );
}

export default App;
